


























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class PresenterSearchResultsStudentGroup extends Vue {

  @Prop()
  readonly item!: Json

  click () {
    if (!this.item.deletedAt) {
      this.$emit('select')
      const parentId = this.item.path.split('.').pop()
      if (+this.$route.params.id !== parentId && +this.$route.params.gid !== this.item.id) {
        this.$router.replace('/presenter/'+parentId+'/students/'+this.item.id)
      }
    }
  }
}
